import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { QuotePersistService } from '../quote-persist.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FileQuoteRequestService } from '@shared/services/file-quote-request.service';
import { TitleRequestPictureService } from '@shared/services/title-request-picture.service';
import { BaseInfoService } from '@api/base-info.service';

@Component({
  selector: 'app-quote-descriptions-pictures',
  templateUrl: './quote-descriptions-pictures.component.html',
  styleUrls: ['./quote-descriptions-pictures.component.scss']
})
export class QuoteDescriptionsPicturesComponent implements OnInit {

  @Output() modalAccept: EventEmitter<void> = new EventEmitter<void>();
  language = 'fa';
  titlePicture;
  formGroup: FormGroup;
  formGroupExplation: FormGroup;
  dangerousGood;
  serviceTypeId;
  fileIdNames: { docId: number; docTitle?: string }[] = [];
  changedFiles = {};
  imageShows = [];
  bankGuaranteeFile = [];
  preTitle: string[] = [];
  preImg: any[] = [];
  communityLicenseImg = {
    userType: 1,
    title: "",
    type: 0,
    imgSrc: null,
    obj: null,
    required: true,
  };
  hasFile = false;
  constructor(
    private fb: FormBuilder,
    public stepper: MatStepper,
    private quotePersistService: QuotePersistService,
    private baseInfoService: BaseInfoService,
    private sanitizer: DomSanitizer,
    private fileQuoteRequestService: FileQuoteRequestService,
    private titleRequestPictureService: TitleRequestPictureService

  ) { }
  ngOnInit() {
    this.getInitialForm();
    this.getTtilePicture();
    this.checkIsClearanceServiceType();
    this.dangerousGood = JSON.parse(localStorage.getItem('dangerousGood'));
  }

  getInitialForm() {
    this.formGroup = this.fb.group({
      bankGuaranteeFile: [null, []],
      docTitle: [null, []],
      fileIdNames: [null, []],
      doc: [null, [Validators.required]],
    });
    this.formGroupExplation = this.fb.group({
      transportInstruction: [''],
      specialTasks: [''],
    });
  }

  uploadAndUpdate(name, event) {
    this.hasFile = true;
    this.changedFiles = {};
    this.changedFiles[name] = event;
    // this.imageRemoverService.sendImage(false);
  }

  loadFile(value) {
    this.imageShows = [];
    const reader = new FileReader();
    reader.readAsDataURL(value);
    reader.onload = () => {
      this.imageShows.push(reader.result);
    };
  }
  removeImage(index) {
    this.bankGuaranteeFile.splice(index, 1);
    this.fileIdNames.splice(index, 1);
    this.preTitle.splice(index, 1);
    this.imageShows.splice(index, 1);
  }
  checkIsClearanceServiceType() {
    this.quotePersistService.getServiceTypeId().subscribe((value => {
      this.serviceTypeId = value;
    }));
  }
  getTtilePicture() {
    this.baseInfoService.getFileTitleQuote().subscribe((res => {
      this.titlePicture = res;
    }));
  }

  addFile() {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      this.bankGuaranteeFile.push(this.changedFiles);
      const prev = [];
      this.bankGuaranteeFile.forEach(item => {
        prev.push(this.sanitizer.bypassSecurityTrustResourceUrl(item.bankGuaranteeFile));
        this.loadFile(item.bankGuaranteeFile);
      });
      this.preImg = prev;
      if (this.formGroup.get('docTitle').value) {
        this.preTitle.push(this.formGroup.value.docTitle);
        const fileIdNames = {
          docId: this.formGroup.value.doc.id,
          docTitle: this.formGroup.value.docTitle,
        };
        this.fileIdNames.push(fileIdNames);
      }
      else {
        if (this.language === 'fa') {
          this.preTitle.push(this.formGroup.value.doc.faTitle);
          const fileIdNames = {
            docId: this.formGroup.value.doc.id
          };
          this.fileIdNames.push(fileIdNames);
        }
        else if (this.language === 'en') {
          this.preTitle.push(this.formGroup.value.doc.enTitle);
          const fileIdNames = {
            docId: this.formGroup.value.doc.id
          };
          this.fileIdNames.push(fileIdNames);
        }
      }
      this.formGroup.reset();
      // this.imageRemoverService.sendImage(true);
    }
  }

  sendFiles() {
    const files = this.bankGuaranteeFile.map(_ => _.bankGuaranteeFile);
    const fileIdNames = this.fileIdNames;
    this.fileQuoteRequestService.setFiles(files);
    this.titleRequestPictureService.setTitle(fileIdNames);
    // this.raiseToast('success', 'عکس ها با موفقیت ثبت شد');
  }

  submitForm() {
    if (this.formGroupExplation.valid) {
      this.modalAccept.emit();
      this.sendFiles();
    }
  }
  inputClicked(inputElement: HTMLInputElement, itemId: string) {
    if (!this.formGroup.controls[itemId].value) {
      inputElement.click();
    }
  }

}